import baseAPI from '@/http'

const router = 'api/municipio/municipiotarefa'

export const cityTaskAPI = {
  create: (cityTask) => baseAPI.post(router, cityTask),
  update: (cityTask) => baseAPI.put(router, cityTask),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  listByCity: (filter) => baseAPI.post(`${router}/list-by-municipio`, filter),
  getTasks: (ids) => baseAPI.post(router + '/get-by-solucoes', ids),
  getTasksProgress: (filter) => baseAPI.post(router + '/get-andamento-by-filtro', filter),
  addBySolucao: (solucao) => baseAPI.post(`${router + '/add-by-solucao'}`, solucao)
}
